/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Ebr_Overwrite_SelectedInputs */

const cs_ebr_overwrite_selected = /** @type {(inputs: Ebr_Overwrite_SelectedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Přepsat jen vybraná pole`)
};

const en_ebr_overwrite_selected = /** @type {(inputs: Ebr_Overwrite_SelectedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Overwrite selected fields only`)
};

/**
* | output |
* | --- |
* | "Overwrite selected fields only" |
*
* @param {Ebr_Overwrite_SelectedInputs} inputs
* @param {{ locale?: "cs" | "en" }} options
* @returns {LocalizedString}
*/
export const ebr_overwrite_selected = /** @type {((inputs?: Ebr_Overwrite_SelectedInputs, options?: { locale?: "cs" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Ebr_Overwrite_SelectedInputs, { locale?: "cs" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_ebr_overwrite_selected(inputs)
	return cs_ebr_overwrite_selected(inputs)
});